export default __webpack_public_path__ + "static/media/bb8.60122026.png";